{
  "countryName": {
    "MK": "North Macedonia"
  }
}